import type * as React from 'react';

interface PageHeaderProps {
  title: string;
  meta?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
}

export function PageHeader({ title, meta, description, actions }: PageHeaderProps) {
  return (
    <header className="flex shrink-0 items-center justify-between gap-4 pb-1 pl-14 pr-6 pt-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight">
          {title}
          {meta ? (
            <span className="ml-2 align-middle text-sm font-normal text-muted-foreground">
              {meta}
            </span>
          ) : null}
        </h1>
        {description ? (
          <div className="mt-1 text-sm text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  );
}
